var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C12.25 0.25 15.75 3.75 15.75 8C15.75 12.2812 12.25 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.75 3.71875 0.25 8 0.25ZM8 14.25C11.4375 14.25 14.25 11.4688 14.25 8C14.25 4.5625 11.4375 1.75 8 1.75C4.53125 1.75 1.75 4.5625 1.75 8C1.75 11.4688 4.53125 14.25 8 14.25ZM11.3438 6.28125C11.3438 8.375 9.0625 8.40625 9.0625 9.1875V9.375C9.0625 9.59375 8.90625 9.75 8.6875 9.75H7.28125C7.0625 9.75 6.90625 9.59375 6.90625 9.375V9.125C6.90625 8 7.75 7.5625 8.375 7.1875C8.9375 6.875 9.28125 6.6875 9.28125 6.28125C9.28125 5.71875 8.59375 5.375 8.03125 5.375C7.3125 5.375 6.96875 5.71875 6.5 6.3125C6.375 6.46875 6.125 6.5 5.96875 6.375L5.09375 5.71875C4.9375 5.59375 4.90625 5.375 5.03125 5.21875C5.75 4.125 6.6875 3.5 8.15625 3.5C9.6875 3.5 11.3438 4.71875 11.3438 6.28125ZM9.3125 11.5C9.3125 12.25 8.71875 12.8125 8 12.8125C7.25 12.8125 6.6875 12.25 6.6875 11.5C6.6875 10.7812 7.25 10.1875 8 10.1875C8.71875 10.1875 9.3125 10.7812 9.3125 11.5Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.9cffb805b9e8eef69a48c646ce50e67f.svg";
export { ForwardRef as ReactComponent };